import React from 'react';
import { sample } from 'lodash';
import Modal from 'components/shared/modal';
import { Icon } from 'ui';
import AnimatedLoadingWave from 'components/shared/AnimatedLoadingWave';

class LoadingModal extends React.Component {
  renderTip() {
    return sample(this.props.tips);
  }

  render() {
    const tip = this.renderTip();

    return (
      <Modal show noPadding loading dismissCallback={null}>
        <div className="Modal-loading">
          <div className="ta-c p-50 lessonlyBrandColor CustomColor--backgroundColor">
            <p className="fz-44 fw-b ff-ss">{t('drafts.publishing.loading')}</p>
          </div>
          <AnimatedLoadingWave className="w-fill CustomColor--svgFill" />
          {tip && (
            <div className="pt-24 pl-32 pr-32">
              <p className="c-gray-darker mb-12 fs-14 ff-ss fw-b tt-u">
                {t('drafts.publishing.product_tip')}
              </p>
              <div className="d-fi pb-40">
                <Icon name="lightbulb-on" className="is-48 mr-16 mb-8" />
                <div className="fz-16 lh-24">{this.renderTip()}</div>
              </div>
            </div>
          )}
        </div>
      </Modal>
    );
  }
}

export default LoadingModal;
